"use client";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { SwiperOptions } from "swiper/types";
import { Autoplay } from "swiper/modules";
import { homeApi } from "@/lib/api/home";
import { useEffect, useState } from "react";
import { constants } from "@/constants";

const instagramData = [
  {
    id: 1,
    link: "https://www.instagram.com",
    src: "/assets/img/instagram/instagram-thumb-1.jpg",
  },
  {
    id: 2,
    link: "https://www.instagram.com",
    src: "/assets/img/instagram/instagram-thumb-2.jpg",
  },
  {
    id: 3,
    link: "https://www.instagram.com",
    src: "/assets/img/instagram/instagram-thumb-3.jpg",
  },
  {
    id: 4,
    link: "https://www.instagram.com",
    src: "/assets/img/instagram/instagram-thumb-4.jpg",
  },
  {
    id: 5,
    link: "https://www.instagram.com",
    src: "/assets/img/instagram/instagram-thumb-5.jpg",
  },
  {
    id: 6,
    link: "https://www.instagram.com",
    src: "/assets/img/instagram/instagram-thumb-2.jpg",
  },
];

// swiper options
const swiper_options: SwiperOptions = {
  slidesPerView: 5,
  spaceBetween: 10,
  freeMode: false,
  loop: true,
  autoplay: {
    delay: 3500,
  },
  breakpoints: {
    "1200": {
      slidesPerView: 5,
    },
    "992": {
      slidesPerView: 4,
    },
    "768": {
      slidesPerView: 3,
    },
    "576": {
      slidesPerView: 1,
    },
    "0": {
      slidesPerView: 1,
    },
  },
};

export default function InstagramArea() {
  const [gallery, setGallery] = useState([]);
  const getGallery = async () => {
    try {
      const gallery = (await homeApi.getGallery()) as any;

      const imagesArray: any = [];

      gallery.forEach((item: any) => {
        const images = item.Images.split("|").filter(
          (image: any) => image.trim() !== ""
        );
        imagesArray?.push(...images);
      });

      setGallery(imagesArray);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getGallery();
  }, []);

  return (
    <div className="gallery-area pb-20">
      <Swiper
        {...swiper_options}
        modules={[Autoplay]}
        className="swiper wow fadeInUp"
        data-wow-delay=".2s"
        style={{
          userSelect: "none",
        }}
      >
        {gallery.map((data, index) => (
          <SwiperSlide key={index} className="tp-gallery-item">
            <Image
              src={constants.UPLOAD_BASE_URL + data}
              alt="gallery-img"
              width={300}
              height={300}
              loading="lazy"
              decoding="async"
              style={{ objectFit: "cover" }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
